import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useRouter } from "next/router";
import Head from "next/head";
import { API_BASE_URL } from "../../libs/generalSettings";
import { get, postJSON } from "../../libs/services/request";
import Language from "../../locales/GetLanguageResourceResponse.json";
import Loader from "../../components/Loader";
import Link from "next/link";
const PageDetail = () => {
  const [mesajIcerik, setMesajIcerik] = useState([]);
  const [goster, setGoster] = useState(true);

  const [pdfContent, setPdfContent] = useState("/docs/2025_emisyon.pdf");
  const [loaderIsShow, setLoaderIsShow] = useState(false);
  const [language, setLanguage] = useState("tr");
  const languageStore = useSelector((state) => state.language);
  const router = useRouter();
  const slug = router.query.slug;

  useEffect(() => {
    (async () => {
      const params = {
        dilKeyWord: languageStore,
        messageKeyWordList: [
          "iptaliadesoru1",
          "iptaliadesoru2",
          "iptaliadesoru3",
          "iptaliadesoru4",
          "iptaliadesoru5",
          // "iptaliadesoru6",
          // "iptaliadesoru7",
          // "iptaliadesoru8",
          // "iptaliadesoru9",
          // "iptaliadesoru10",
          // "iptaliadesoru11",
          // "iptaliadesoru12",
          // "iptaliadesoru13",
          // "iptaliadesoru14",
          // "iptaliadesoru15",
          // "iptaliadesoru16",
          // "iptaliadesoru17",
          // "iptaliadesoru18",
          // "iptaliadesoru19",
          // "iptaliadesoru20",
          // "iptaliadesoru21",
          // "iptaliadesoru22",
          // "iptaliadesoru23",
          // "iptaliadesoru24",
          // "iptaliadesoru25",
          // "iptaliadesoru26",
          // "iptaliadesoru27",
          // "iptaliadesoru28",
          // "iptaliadesoru29",
          // "iptaliadesoru30",
          // "iptaliadesoru31",
          // "iptaliadesoru32",

          "iptaliadecevap1",
          "iptaliadecevap2",
          "iptaliadecevap3",
          "iptaliadecevap4",
          "iptaliadecevap5",
          "iptaliadecevap11",
          "iptaliadecevap12",
          // "iptaliadecevap6",
          // "iptaliadecevap7",
          // "iptaliadecevap8",
          // "iptaliadecevap9",
          // "iptaliadecevap10",
          // "iptaliadecevap11",
          // "iptaliadecevap12",
          // "iptaliadecevap13",
          // "iptaliadecevap14",
          // "iptaliadecevap15",
          // "iptaliadecevap16",
          // "iptaliadecevap17",
          // "iptaliadecevap18",
          // "iptaliadecevap19",
          // "iptaliadecevap20",
          // "iptaliadecevap21",
          // "iptaliadecevap22",
          // "iptaliadecevap23",
          // "iptaliadecevap24",
          // "iptaliadecevap25",
          // "iptaliadecevap26",
          // "iptaliadecevap27",
          // "iptaliadecevap28",
          // "iptaliadecevap29",
          // "iptaliadecevap30",
          // "iptaliadecevap31",
          // "iptaliadecevap32",

          "aboneIslemleriParagraf1",
          "aboneIslemleriParagraf2",
          "uyari2",
          "yurtdisiiadeleriparali",
          "bizeulasin",
          "bizeulasinmesaj",
          "pttas",
          "degerlikagitlardairebaskanligi",
          "filatelimudurlugu",
          "yurtici",
          "telefon",
          "fax",
          "epostaadresi",
          "adresi",
        ],
      };

      await postJSON(`${API_BASE_URL}/mesajIcerikleriGetir`, params).then(
        (result) => {
          {
            if (result.sonuc === true) {
              setLanguage(languageStore);
              setMesajIcerik(result.data);
              setLoaderIsShow(true);
              return (<IptalVeIade />), (<BizeUlasin />);
            } else {
            }
          }
        }
      );
    })();
  }, [languageStore]);

  const AboneIslemleri = () => {
    return (
      <>
        <h5 className="color-gray-800 mb-10">
          {Language[languageStore].aboneIslemleri}
        </h5>
        <div className="row mt-20">
          <div className="col-lg-12">
            <p className="font-sm font-medium color-gray-700 mb-15">
              {mesajIcerik.aboneIslemleriParagraf1}
            </p>
            <p className="font-sm font-medium color-gray-700 mb-15">
              {mesajIcerik.aboneIslemleriParagraf2}
            </p>

            <h5 className="color-gray-800 mb-10">
              {Language[languageStore].dosyaIndirTitle}
            </h5>
            <ul className="list-services mt-20">
              <li className="hover-up">
                <a
                  target="_blank"
                  className="color-gray-800"
                  href="/docs/abone_formu.pdf">
                  {Language[languageStore].aboneFormuTiklaTitle}
                </a>
              </li>
              <li className="hover-up">
                <a
                  target="_blank"
                  className="color-gray-800"
                  href="/docs/abonelik_kvk.pdf">
                  {Language[languageStore].filateliAboneligiTitle}
                </a>
              </li>
              <li className="hover-up">
                <a
                  target="_blank"
                  className="color-gray-800"
                  href="/docs/banka_hesaplari.pdf">
                  {Language[languageStore].bankaHesapNumaralariTitle}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </>
    );
  };
  const IptalVeIade = () => {
    return (
      <>
        <h5 className="color-gray-800 mb-10">
          {Language[languageStore].iptalVeIadeKosullari}
        </h5>
        <div className="row mt-20">
          <div className="col-lg-12">
            <p className="font-sm font-medium color-gray-700 mb-15">
              {mesajIcerik.iptaliadesoru1}
            </p>
            <p className="font-sm font-medium color-gray-700 mb-15">
              {mesajIcerik.iptaliadecevap1}
            </p>
            <p className="font-sm font-medium color-gray-700 mb-15">
              {mesajIcerik.iptaliadecevap11}
            </p>
            <p className="font-sm font-medium color-gray-700 mb-15">
              {mesajIcerik.iptaliadecevap12}
            </p>
            <p className="font-sm font-medium color-gray-700 mb-15">
              {mesajIcerik.iptaliadesoru2}
            </p>
            <p className="font-sm font-medium color-gray-700 mb-15">
              {mesajIcerik.iptaliadecevap2}
            </p>
            <p className="font-sm font-medium color-gray-700 mb-15">
              {mesajIcerik.iptaliadesoru3}
            </p>
            <p className="font-sm font-medium color-gray-700 mb-15">
              {mesajIcerik.iptaliadecevap3}
            </p>
            <p className="font-sm font-medium color-gray-700 mb-15">
              {mesajIcerik.iptaliadecevap31}
            </p>
            <p className="font-sm font-medium color-gray-700 mb-15">
              {mesajIcerik.iptaliadecevap32}
            </p>

            <p className="font-sm font-medium color-gray-700 mb-15">
              {mesajIcerik.iptaliadesoru4}
            </p>
            <p className="font-sm font-medium color-gray-700 mb-15">
              {mesajIcerik.iptaliadecevap4}
            </p>
            <p className="font-sm font-medium color-gray-700 mb-15">
              {mesajIcerik.iptaliadesoru5}
            </p>
            <p className="font-sm font-medium color-gray-700 mb-15">
              {mesajIcerik.iptaliadecevap5}
            </p>

            <h5 className="color-gray-800 mb-10">{mesajIcerik.uyari2}</h5>
            <p className="font-sm font-medium color-gray-700 mb-15">
              {mesajIcerik.yurtdisiiadeleriparali}
            </p>
          </div>
        </div>
      </>
    );
  };
  const BizeUlasin = () => {
    return (
      <>
        <h5 className="color-gray-800 mb-5 text-center">
          {Language[languageStore].bizeUlasin}
        </h5>
        <div className="row mt-20 text-center">
          <div className="col-lg-12">
            <p className="font-sm font-medium color-gray-700 mb-15">
              {mesajIcerik.bizeulasinmesaj}
            </p>
            <p className="font-sm font-bold color-gray-900 mb-15">
              {mesajIcerik.pttas}
            </p>
            <p className="font-sm font-bold color-gray-900 mb-15">
              {mesajIcerik.degerlikagitlardairebaskanligi}
            </p>
            <p className="font-sm font-bold color-gray-900 mb-15">
              {mesajIcerik.filatelimudurlugu}
            </p>
            <p className="font-sm font-medium color-gray-900 mb-15">
              {mesajIcerik.yurtici}
            </p>
            <p className="font-sm font-medium color-gray-900 mb-15">
              {mesajIcerik.telefon}
              <a href="tel:+903125095733">0 312 509 57 33</a>
            </p>
            <p className="font-sm font-medium color-gray-900 mb-15">
              {mesajIcerik.fax}0 312 309 59 65
            </p>
            <p className="font-sm font-medium color-gray-900 mb-15">
              {mesajIcerik.epostaadresi}:
              <a href="mailto:filateli@ptt.gov.tr">filateli@ptt.gov.tr</a>
            </p>
            <p className="font-sm font-medium color-gray-900 mb-15">
              {mesajIcerik.adresi}
            </p>
            <p className="font-sm font-medium color-gray-900 mb-15">
              {mesajIcerik.pttas}
              <br />
              {mesajIcerik.degerlikagitlardairebaskanligi}&nbsp;
              {mesajIcerik.filatelimudurlugu}
              <br />
              Hacıbayram Mahallesi Şehit Teğmen Kalmaz Cad. No:2
              <br />
              Ulus/ Altındağ/ Ankara
            </p>
          </div>
        </div>
      </>
    );
  };
  const FilateliDernekFederasyonu = () => {
    return (
      <>
        <h5 className="color-gray-800 mb-5 text-center">
          Türkiye Filateli Dernekleri Federasyonu Türkiye için
        </h5>
        <div className="row mt-20 text-center">
          <div className="col-lg-12">
            <p className="font-sm font-bold color-gray-900 mb-15">
              {mesajIcerik.pttas}
            </p>
            <p className="font-sm font-medium color-gray-900 mb-15">
              Telefon Numaraları
            </p>
            <p className="font-sm font-medium color-gray-900 mb-15">
              <p>
                0 212 232 99 26 <br /> 0 212 232 99 27
              </p>
            </p>
            <p className="font-sm font-medium color-gray-900 mb-15">Fax</p>
            <p className="font-sm font-medium color-gray-900 mb-15">
              0 212 231 06 24
            </p>
            <p className="font-sm font-medium color-gray-900 mb-15">
              <b>Posta Göndermek için lütfen aşağıdaki adresi kullanın</b>
            </p>

            <p className="font-sm font-medium color-gray-900 mb-15">
              Türkiye Filateli Dernekleri Federasyonu Şafak sokak No:4 Kat: 4
              <br />
              Nişantaşı 3437 <br />
              İSTANBUL/TÜRKİYE
            </p>
          </div>
        </div>
      </>
    );
  };
  const FilateliEgitimSeminerleri = () => {
    return (
      <>
        <div className="col-md-4">
          <div className="image-box">
            <div className="mb-20" />

            <a href="#">
              <img
                style={{ borderRadius: "1%" }}
                src="/static/imgs/template/filateli-egitim-seminerleri.jpg"
                alt="Filateli Eğitim Seminerleri"
              />
            </a>
          </div>
        </div>
        <div className="col-md-8">
          {" "}
          <div className="blog-info">
            <a className="color-gray-1100" href="#">
              <h4 className="mb-15">Filateli Eğitim Seminerleri</h4>
            </a>
            <p className="font-md color-gray-500">
              Çocuklarımızın ve gençlerimizin zararlı alışkanlıklardan
              korunmasının en güzel ve eğlenceli yollarından biri olarak görülen
              ve kişilik gelişimine sayısız katkı sağlayan filatelinin
              bilinirliğini ve bir hobi dalı olarak benimsenmesini
              yaygınlaştırmak amacıyla, personelimiz tarafından ilköğretim
              okullarında ve düzenlenen sergilere gelen ziyaretçi öğrencilere
              filateli seminerleri verilmektedir.
            </p>
            <p className="font-md color-gray-500 mt-2">
              Bu çerçevede, çocuklara yönelik olarak hazırlanan hediyeler ile bu
              eğitimler daha ilgi çekici hale getirilmektedir. Şirketimizin
              ülkemizin geleceği olan çocuklara yönelik ilgisinin internet
              ortamında da hayata geçirilmesi amacıyla, çocuklara yönelik bir
              web sitesi hazırlanması çalışmalarında son aşamaya gelinmiştir.
            </p>
            <p className="font-md color-gray-500 mt-2">
              {" "}
              Şirketimizin ülkemizin geleceği olan çocuklara yönelik ilgisinin
              internet ortamında da hayata geçirilmesi amacıyla, çocuklara
              yönelik bir web sitesi hazırlanması çalışmalarında son aşamaya
              gelinmiştir.
            </p>
            <p className="font-md color-gray-500 mt-2">
              {" "}
              Filateli hizmetlerimizin niteliğinin yükseltilmesi, abonelik
              sisteminin yerel düzeyde daha etkin olarak yürütülmesi, damga
              uygulamalarında ortaya çıkan sorunların en az düzeye indirilmesi,
              sergilerin profesyonelce düzenlenmesi gibi hedeflere ulaşmak
              amacıyla şirketimiz taşra personeline yönelik olarak da filateli
              seminerleri düzenlenmektedir. Söz konusu seminerler ile tüm
              Başmüdürlüklerimizden ilgili personele teorik ve pratik
              bilgilendirme yapılmaktadır.
            </p>
          </div>
        </div>
      </>
    );
  };
  const EmisyonProgrami = () => {
    const isMobile = {
      Android: () => navigator.userAgent.match(/Android/i),
      BlackBerry: () => navigator.userAgent.match(/BlackBerry/i),
      iOS: () => navigator.userAgent.match(/iPhone|iPad|iPod/i),
      Opera: () => navigator.userAgent.match(/Opera Mini/i),
      Windows: () =>
        navigator.userAgent.match(/IEMobile/i) ||
        navigator.userAgent.match(/WPDesktop/i),
      Desktop: () => !isMobile.any(), // "Desktop" için yeni kontrol ekledik
      any: () =>
        isMobile.Android() ||
        isMobile.BlackBerry() ||
        isMobile.iOS() ||
        isMobile.Opera() ||
        isMobile.Windows(),
    };
    // Örneğin, "Desktop" cihazı mı kontrol etmek için:
    if (isMobile.Desktop()) {
      setGoster(true);
    } else {
      setGoster(false);
    }
    return (
      <>
        {goster && (
          <>
            <h5 className="color-gray-800 mb-5 text-center">
              {Language[languageStore].emisyonProgramiTitle}
            </h5>
          </>
        )}

        <div className="row mt-20 text-center">
          <div className="col-lg-3 order-last order-lg-first">
            <div className="sidebar-border mb-0">
              <div className="sidebar-head">
                <h6 className="color-gray-900">
                  {Language[languageStore].emisyonProgramiArsivi}
                </h6>
              </div>
              <div className="sidebar-content">
                <ul className="list-nav-arrow">
                  <li className="hover-up active">
                    <Link
                      onClick={() => setPdfContent("/docs/2014_emisyon.pdf")}
                      href={goster === false ? "/docs/2014_emisyon.pdf" : "#"}
                      target={goster === true ? "" : "_blank"}
                      title="2014 - Emisyon Programı"
                      className="color-gray-900">
                      2014 - {Language[languageStore].emisyonProgramiTitle}
                    </Link>
                  </li>
                  <li className="hover-up active">
                    <Link
                      onClick={() => setPdfContent("/docs/2015_emisyon.pdf")}
                      href={goster === false ? "/docs/2015_emisyon.pdf" : "#"}
                      target={goster === true ? "" : "_blank"}
                      title="2015 - Emisyon Programı"
                      className="color-gray-900">
                      2015 - {Language[languageStore].emisyonProgramiTitle}
                    </Link>
                  </li>
                  <li className="hover-up active">
                    <Link
                      onClick={() => setPdfContent("/docs/2016_emisyon.pdf")}
                      href={goster === false ? "/docs/2016_emisyon.pdf" : "#"}
                      target={goster === true ? "" : "_blank"}
                      title="2016 - Emisyon Programı"
                      className="color-gray-900">
                      2016 - {Language[languageStore].emisyonProgramiTitle}
                    </Link>
                  </li>
                  <li className="hover-up active">
                    <Link
                      onClick={() => setPdfContent("/docs/2017_emisyon.pdf")}
                      href={goster === false ? "/docs/2017_emisyon.pdf" : "#"}
                      target={goster === true ? "" : "_blank"}
                      title="2017 - Emisyon Programı"
                      className="color-gray-900">
                      2017 - {Language[languageStore].emisyonProgramiTitle}
                    </Link>
                  </li>
                  <li className="hover-up active">
                    <Link
                      onClick={() => setPdfContent("/docs/2018_emisyon.pdf")}
                      href={goster === false ? "/docs/2018_emisyon.pdf" : "#"}
                      target={goster === true ? "" : "_blank"}
                      title="2018 - Emisyon Programı"
                      className="color-gray-900">
                      2018 - {Language[languageStore].emisyonProgramiTitle}
                    </Link>
                  </li>
                  <li className="hover-up active">
                    <Link
                      onClick={() => setPdfContent("/docs/2019_emisyon.pdf")}
                      href={goster === false ? "/docs/2019_emisyon.pdf" : "#"}
                      target={goster === true ? "" : "_blank"}
                      title="2019 - Emisyon Programı"
                      className="color-gray-900">
                      2019 - {Language[languageStore].emisyonProgramiTitle}
                    </Link>
                  </li>
                  <li className="hover-up active">
                    <Link
                      onClick={() => setPdfContent("/docs/2020_emisyon.pdf")}
                      href={goster === false ? "/docs/2020_emisyon.pdf" : "#"}
                      target={goster === true ? "" : "_blank"}
                      title="2020 - Emisyon Programı"
                      className="color-gray-900">
                      2020 - {Language[languageStore].emisyonProgramiTitle}
                    </Link>
                  </li>
                  <li className="hover-up active">
                    <Link
                      onClick={() => setPdfContent("/docs/2021_emisyon.pdf")}
                      href={goster === false ? "/docs/2021_emisyon.pdf" : "#"}
                      target={goster === true ? "" : "_blank"}
                      title="2021 - Emisyon Programı"
                      className="color-gray-900">
                      2021 - {Language[languageStore].emisyonProgramiTitle}
                    </Link>
                  </li>
                  <li className="hover-up active">
                    <Link
                      onClick={() => setPdfContent("/docs/2022_emisyon.pdf")}
                      href={goster === false ? "/docs/2022_emisyon.pdf" : "#"}
                      target={goster === true ? "" : "_blank"}
                      title="2022 - Emisyon Programı"
                      className="color-gray-900">
                      2022 - {Language[languageStore].emisyonProgramiTitle}
                    </Link>
                  </li>
                  <li className="hover-up active">
                    <Link
                      onClick={() => setPdfContent("/docs/2023_emisyon.pdf")}
                      href={goster === false ? "/docs/2023_emisyon.pdf" : "#"}
                      target={goster === true ? "" : "_blank"}
                      title="2023 - Emisyon Programı"
                      className="color-gray-900">
                      2023 - {Language[languageStore].emisyonProgramiTitle}
                    </Link>
                  </li>
                  <li className="hover-up active">
                    <Link
                      onClick={() => setPdfContent("/docs/2024_emisyon.pdf")}
                      href={goster === false ? "/docs/2024_emisyon.pdf" : "#"}
                      target={goster === true ? "" : "_blank"}
                      title="2024 - Emisyon Programı"
                      className="color-gray-900">
                      2024 - {Language[languageStore].emisyonProgramiTitle}
                    </Link>
                  </li>
                  <li className="hover-up active">
                    <Link
                      onClick={() => setPdfContent("/docs/2025_emisyon.pdf")}
                      href={goster === false ? "/docs/2024_emisyon.pdf" : "#"}
                      target={goster === true ? "" : "_blank"}
                      title="2024 - Emisyon Programı"
                      className="color-gray-900">
                      2025 - {Language[languageStore].emisyonProgramiTitle}
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          {goster && (
            <>
              {" "}
              <div
                className="col-lg-9 order-first order-lg-last"
                id="pdf-goster">
                <div className="banner-ads-top py-3 mb-10">
                  {" "}
                  <object
                    data={`${pdfContent}`}
                    type="application/pdf"
                    width="900px" // Ekranın tam genişliğinde
                    height="500px" // Belirli bir yükseklikte
                    style={{ borderRadius: "1%" }}></object>
                </div>
              </div>
            </>
          )}
        </div>
      </>
    );
  };
  const pageTitle =
    slug != undefined
      ? slug === "abone-islemleri"
        ? Language[languageStore].aboneIslemleri
        : slug === "iptal-ve-iade-kosullari"
        ? Language[languageStore].iptalVeIadeKosullari
        : slug === "bize-ulasin"
        ? Language[languageStore].bizeUlasin
        : slug === "emisyon-programi"
        ? Language[languageStore].emisyonProgrami
        : slug === "filateli-dernek-federasyonu"
        ? Language[languageStore].FilateliDernekFederasyonu
        : slug === "filateli-egitim-seminerleri"
        ? Language[languageStore].menuFilateliEgitimSeminer
        : ""
      : "";
  return (
    <>
      <Head>
        <title>
          {Language[languageStore].webTitle} | {pageTitle}
        </title>
      </Head>
      {!loaderIsShow ? <Loader /> : ""}
      <section className="section-box shop-template mt-30">
        <div className="container">
          <div className="row">
            {slug === "abone-islemleri" ? (
              <div className="col-lg-10 mx-auto">
                <AboneIslemleri />
              </div>
            ) : slug === "iptal-ve-iade-kosullari" ? (
              <IptalVeIade />
            ) : slug === "bize-ulasin" ? (
              <BizeUlasin />
            ) : slug === "emisyon-programi" ? (
              <EmisyonProgrami />
            ) : slug === "filateli-dernek-federasyonu" ? (
              <FilateliDernekFederasyonu />
            ) : slug === "filateli-egitim-seminerleri" ? (
              <FilateliEgitimSeminerleri />
            ) : (
              ""
            )}
          </div>
        </div>
      </section>
    </>
  );
};
export default PageDetail;
